export const GET_ORGANISATION_WITHOUT_LOGIN         = 'GET_ORGANISATION_WITHOUT_LOGIN';
export const GET_ORGANISATION                       = 'GET_ORGANISATION';